var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Modal from 'react-modal';
import _ from 'lodash';
import './tjk.odds.modal.css';
import ExitIcon from '../../../assets/feather/x-circle.svg';
import { addToTJKBetSlip } from '../tjk.betslip.service';
import { tjkFobHorseSelectionTypes } from '../tjk.store';
export default function TjkOddsModal(_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, run = _a.run, bettingTypeId = _a.bettingTypeId, columnNo = _a.columnNo;
    var horseMap = ((run === null || run === void 0 ? void 0 : run.horses) || []).reduce(function (acc, h) {
        acc[Number(h.no)] = h;
        return acc;
    }, {});
    var getHorseNameForOdd = function (horsesNo) {
        var _a, _b, _c;
        try {
            var parts = horsesNo.toString().split('-');
            if (parts.length > 1) {
                return (((_a = horseMap[Number(parts[0])]) === null || _a === void 0 ? void 0 : _a.name) || parts[0]) + ' - ' + (((_b = horseMap[Number(parts[1])]) === null || _b === void 0 ? void 0 : _b.name) || parts[1]);
            }
            return ((_c = horseMap[Number(horsesNo)]) === null || _c === void 0 ? void 0 : _c.name) || horsesNo;
        }
        catch (_d) {
            return horsesNo;
        }
    };
    var calculateOdd = function (eventOdd) {
        if ((eventOdd === null || eventOdd === void 0 ? void 0 : eventOdd.show) && Number(eventOdd.win_odds) > 1)
            return eventOdd.win_odds;
        return (eventOdd === null || eventOdd === void 0 ? void 0 : eventOdd.status) === 'o' ? 'KO' : '🔒';
    };
    var handleOddClick = function (odds) {
        if (odds.horse_no.toString().includes('-')) {
            var firstNo_1 = Number(odds.horse_no.split('-')[0]);
            var secondNo_1 = Number(odds.horse_no.split('-')[1]);
            var h1 = run.horses.find(function (h) { return Number(h.no) === firstNo_1; });
            var h2 = run.horses.find(function (h) { return Number(h.no) === secondNo_1; });
            if (h1)
                addToTJKBetSlip(columnNo, run, h1, 'toggle');
            if (h2)
                addToTJKBetSlip(columnNo, run, h2, 'toggle');
        }
        else {
            var horse = run.horses.find(function (h) { return Number(h.no) === Number(odds.horse_no); });
            if (horse)
                addToTJKBetSlip(columnNo, run, horse, 'toggle');
        }
        onClose();
    };
    var getFilteredOdds = function () {
        if (!(run === null || run === void 0 ? void 0 : run.event_odds))
            return [];
        return _.orderBy(Object.values(run.event_odds).filter(function (odd) {
            if (tjkFobHorseSelectionTypes.includes(bettingTypeId)) {
                return bettingTypeId === 1885
                    ? odd.horse_no.toString().includes('-') && odd.event_id.includes('EX')
                    : odd.horse_no.toString().includes('-') && !odd.event_id.includes('EX');
            }
            if (bettingTypeId === 1886)
                return odd.event_id.includes('T2');
            if (bettingTypeId === 1887)
                return odd.event_id.includes('T3');
            if (bettingTypeId === 1888)
                return odd.event_id.includes('T4');
            return (!odd.horse_no.toString().includes('-') &&
                !['T2', 'T3', 'T4'].some(function (t) { return odd.event_id.includes(t); }));
        }), [function (e) { return Number(e.win_odds); }]);
    };
    return (_jsxs(Modal, __assign({ isOpen: isOpen, onRequestClose: onClose, style: {
            content: {
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                width: '420px',
                maxHeight: 'calc(100% - 40px)',
                marginRight: '-50%',
                maxWidth: 'calc(100% - 40px)',
                padding: '0px',
                transform: 'translate(-50%, -50%)',
                background: 'var(--color-bg-white)',
                borderRadius: '8px',
                border: '0',
            },
            overlay: {
                zIndex: 5,
                backgroundColor: 'rgba(0, 0, 0, 0.25)',
                backdropFilter: 'blur(10px)',
            },
        }, contentLabel: "" }, { children: [_jsxs("div", __assign({ className: "modal-header" }, { children: [_jsx("div", __assign({ className: "w-100 d-flex justify-content-end pr-2 mt-2" }, { children: _jsx("img", { src: ExitIcon, width: 24, className: "cursor-pointer invert-color", onClick: onClose }, void 0) }), void 0), _jsx("h4", __assign({ className: "w-100 text-center align-self-center mb-2" }, { children: "Oranlar" }), void 0)] }), void 0), _jsx("div", __assign({ className: "modal-body p-3" }, { children: _jsx("div", __assign({ className: "tjk-odds-modal-list" }, { children: getFilteredOdds().map(function (odds, index) { return (_jsx("div", __assign({ id: "tjk-odd-row-".concat(index), className: "line", onMouseOver: function () { var _a; return (_a = document.getElementById("tjk-odd-row-".concat(index))) === null || _a === void 0 ? void 0 : _a.classList.add('high'); }, onMouseOut: function () { var _a; return (_a = document.getElementById("tjk-odd-row-".concat(index))) === null || _a === void 0 ? void 0 : _a.classList.remove('high'); }, onClick: function () { return handleOddClick(odds); } }, { children: _jsxs("div", __assign({ className: "tjk-odds-modal-horse-name cursor-pointer" }, { children: [_jsxs("div", __assign({ className: "d-flex" }, { children: [_jsx("span", { children: odds.horse_no }, void 0), "\u00A0", _jsx("span", { children: getHorseNameForOdd(odds.horse_no) }, void 0)] }), void 0), _jsx("div", __assign({ className: "tjk-odds-btn" }, { children: calculateOdd(odds) }), void 0)] }), void 0) }), index)); }) }), void 0) }), void 0)] }), void 0));
}
